module.exports = __webpack_public_path__ + "img/背景图@2x.b59475a3.webp";